<template>
  <div class="review">
    <p class="v1-back-tip" style="margin: 10px 0;">
      <span @click="$router.back()" style="float: left;">
        <i class="el-icon-arrow-left"></i>
        返回
      </span>
    </p>
    <div class="content">
      <div v-if="currentItem.images && currentItem.images.length > 0" class="left">
        <div v-if="visible" class="image-preview">
          <mark-image v-for="img, jIndex in currentItem.images" :key="currentItem.detailId + 'image' + jIndex" :img="img" :setting="setting">
            <div v-if="showRawPaper" :style="iconStyle(img)">
              <el-tooltip effect="dark" content="查看原卷" trigger="hover" placement="top-end">
                <div class="paper-preview" @click="viewMosaic(currentItem)">
                  <i class="el-icon-search"></i>
                </div>
              </el-tooltip>
            </div>
          </mark-image>
        </div>
        <div class="zoom" v-if="currentItem.detailId">
          <span>缩放</span>
          <span class="el-icon-minus"></span>
          <el-slider :max="300" :min="60" v-model="setting.silderValue" @input="setting.scale = setting.silderValue / 100"></el-slider>
          <span class="el-icon-plus"></span>
          <span>{{ setting.silderValue }}%</span>
        </div>
      </div>
      <div v-else class="left page-empty">
        <data-empty :loading="loading"></data-empty>
      </div>
      <yue-read-two-list class="right"></yue-read-two-list>
    </div>

    <!-- 利用el-image实现代码控制预览图片 -->
    <el-image class="priview-img" ref="priview" :src="previewImg.src" :preview-src-list="[previewImg.src]"></el-image>
  </div>
</template>
<script>
import { configApi } from '@/api/api';
import { examApi, gradingApi } from '@/v2/utils/api';
import { mapGetters } from "vuex";
import MarkImage from './components/MarkImage.vue';
import util from '@/v2/utils/util';
import DataEmpty from '@/v3/components/DataEmpty.vue';

export default {
  name: 'paperRevivew',
  data () {
    return {
      loading: false,
      setting: {
        readType: 4,
        scale: 0.8,
        silderValue: 80
      },
      currentItem: {},
      list: [],
      previewImg: { src: '' },
      visible: true,
      showRawPaper: false
    }
  },
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo"
    })
  },
  mounted () {
    this.loading = true
    // 预览原卷
    this.lookRawPaper()
  },
  methods: {
    questionNumsYueReadTwoList () {
      const params = {
        examId: this.$route.query.examId,
        teacherId: this.userInfo.userId,
        schoolId: this.$route.query.schoolId,
        judgeType: this.$route.query.readType
      }
      return gradingApi.getExamQuestions(params).then(resp => {
        const list = []
        if (resp.body) {
          resp.body.forEach(item => {
            list.push({ questionNums: [item] })
          })
        }

        return {
          result: list
        }
      })
    },
    loadYueReadTwoList (info) {
      let key = 'FIRST'
      if (util.markTypeDict) {
        key = Object.keys(util.markTypeDict)[this.$route.query.readType - 1] || 'FIRST'
      }
      let params = {
        examId: this.$route.query.examId,
        teacherId: this.userInfo.userId,
        schoolId: this.$route.query.schoolId,
        teacherType: key,
        ...info,
        currentPage: info.pageNo,
      };
      return gradingApi.getReadOverHistory(params).then(resp => {
        if (resp.body) {
          this.list = resp.body.items
        }
        return {
          result: resp.body.items || [],
          total: resp.body.totalSize,
          code: resp.success ? 200 : 0,
          message: resp.message
        }
      })
    },
    getMarkScore: async function () {
      const ques = this.currentItem
      if (!ques) return
      const params = {
        examId: this.$route.query.examId,
        teacherId: this.userInfo.userId,
        gradingType: this.$route.query.readType,
        detailId: ques.detailId
      };
      await gradingApi.getReadMark(params, ques)
    },
    loadMarkYueReadTwoList (info) {
      this.currentItem = info == null ? {} : info
      this.loading = false
    },
    updateYueReadTwoList (info) {
      const params = {
        examId: this.$route.query.examId,
        detailId: info.detailId,
        id: info.id,
        academicYear: info.academicYear,
        score: info.score,
        evaluateType: info.evaluateType,
        isSplit: info.isSplit,
        questionSplitVos: info.questionSplitVos
      }

      return gradingApi.updateReadOverHistory(params).then(async resp => {
        const params = {
          examId: this.$route.query.examId,
          teacherId: this.userInfo.userId,
          detailId: info.detailId,
          gradingType: this.$route.query.readType,
          schoolId: info.schoolId,
          num: info.num,
          ossUrl: info.ossUrl
        }
        this.visible = false
        this.removeScoreMarks(info)
        await gradingApi.updateReadMark(params, info)
        this.$nextTick(() => {
          this.visible = true
        })
        return {
          code: resp.success ? 200 : 0,
          message: resp.message
        }
      })
    },
    removeScoreMarks: function (info) {
      console.log('移除标记数据')
      const currentQuestion = info
      for (let index = 0; index < currentQuestion.images.length; index++) {
        // 从数据结构移除
        const element = currentQuestion.images[index];
        element.scores = []
        const objects = element.canvas.getObjects()
        // 从画布移除
        for (let index = 0; index < objects.length; index++) {
          const item = objects[index];
          if (item.id) {
            element.canvas.remove(item)
          }
        }
      }
    },
    lookRawPaper () {
      configApi.getConfigByTypes(this.$route.query.schoolId, ['SHOW_PAPER_IN_GRADING']).then(res => {
        if (res.body && res.body.length) {
          this.showRawPaper = parseInt(res.body[0].configValue);
        }
      })
    },
    iconStyle (img) {
      if (this.setting.expandArea) {
        return {
          position: 'absolute',
          right: 0,
          bottom: '32px',
        }
      } else {
        return {
          position: 'absolute',
          top: (img.rawHeight * this.setting.scale) - 32 + 'px',
          left: (img.rawWidth * this.setting.scale) + 'px'
        }
      }
    },
    viewMosaic (item) {
      if (item.mosaicPaperUrl) {
        this.viewImage(item.mosaicPaperUrl);
      } else {
        let params = {
          examId: this.$route.query.examId,
          resultId: item.resultId,
          url: encodeURIComponent(item.ossUrl.split('?')[0])
        };
        const role = this.$route.query.isMore.indexOf('SCHOOL') >= 0 ? 'school' : 'region'
        examApi.getStudentMosaicPaper(params, role).then(res => {
          if (res.body && res.body.mosaicUrl) {
            item.mosaicPaperUrl = res.body.mosaicUrl;
            this.viewMosaic(item);
          } else {
            this.$message.error(res.message || '获取学生答题卡失败');
          }
        });
      }
    },
    viewImage (src) {
      this.previewImg.src = src;
      this.$refs.priview.showViewer = true;
    },
  },
  components: { MarkImage, DataEmpty }
}
</script>
<style lang="scss" scoped>
.review {
  display: flex;
  flex-direction: column;
  padding-bottom: 32px;
}

.review .header {
  display: flex;
  height: 50px;
  line-height: 50px;
  font-size: 14px;
  color: #9a9a9a;
  margin-top: 4px;
  margin-bottom: 4px;
}

.review .header span {
  padding-left: 5px;
}

.review .header .back {
  padding-right: 10px;
  cursor: pointer;
}

.review .header .back img {
  vertical-align: middle;
  margin-top: -3px;
}

.review .header .back:hover span {
  color: $color-theme;
}

.review .content {
  display: flex;
  position: relative;
}

.review .left {
  margin-right: 20px;
  flex: 1;
  background: white;
  display: flex;
  flex-wrap: wrap;
  overflow: auto;
  position: relative;
  padding: 20px;
  box-sizing: border-box;
}

.review .left .zoom {
  position: absolute;
  bottom: 0;
  width: 355px;
  right: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 1000;
  background-color: #fff;
}

.review .left .zoom .el-slider {
  width: 240px;
}

.review .left .images {
  position: relative;
}

.review .left .images .mark-score {
  position: absolute;
  display: inline-block;
  font-size: 24px;
  width: 150px;
}

.review .left .images .right_score {
  color: #54d14e;
  font-weight: bold;
  vertical-align: top;
}

.review .left .images .error_score {
  color: #f22c60;
  font-weight: bold;
  vertical-align: top;
}

.review .left .images .div-scale .ques-img {
  width: 100%;
  height: 100%;
}

.review .left .images .div-scale {
  position: relative;
  transform-origin: 0 0;
}

.review .left .images .paper-preview {
  transition: visibility 0.2s;
  visibility: hidden;
  position: absolute;
  right: 0;
  width: 32px;
  height: 32px;
  background-color: rgba(0, 0, 0, 0.25);
  text-align: center;
  line-height: 32px;
  font-size: 20px;
  color: #fff;
  border-radius: 2px;
}

.review .left .images .paper-preview .img {
  z-index: 1;
  position: absolute;
  width: 32px;
  height: 32px;
  opacity: 0;
  left: 0;
  top: 0;
}

.image-preview {
  height: calc(100% - 50px);
  overflow: auto;
  width: 100%;
}

.priview-img ::v-deep .el-image__inner,
.priview-img ::v-deep .el-image__error {
  display: none;
}

.paper-preview {
  transition: visibility 0.2s;
  visibility: hidden;
  position: absolute;
  right: 0;
  width: 32px;
  height: 32px;
  background-color: rgba(0, 0, 0, 0.25);
  text-align: center;
  line-height: 32px;
  font-size: 20px;
  color: #fff;
  border-radius: 2px;
}

.image-preview:hover .paper-preview {
  visibility: visible;
}

.paper-preview:hover {
  cursor: zoom-in;
}

.page-empty {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 834px;
}
</style>